<template>
  <div style="margin-top: 10px">
    <el-form :model="formData" label-width="200px" :rules="rules">
      <div>{{time_consuming}}</div>
      <el-row >
        <el-col  :span="11" >
          <el-form-item label="设备类型：" prop="star1">
            <el-select v-model="formData.device_id"  disabled placeholder="设备类型" clearable style="width: 250px">
              <el-option v-for="dict in eqDeviceTypeAll" :key="dict.value" :label="dict.label" :value="dict.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col  :span="11" >
          <el-form-item label="部位名称：" prop="star2">
            <el-select v-model="formData.position_id" disabled  placeholder="部位名称" clearable style="width: 250px">
              <el-option v-for="dict in eqPositionTypeAll" :key="dict.value" :label="dict.label" :value="dict.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col  :span="24" >
          <div style="margin-left: 90px">
            <span>保养标准方法：&nbsp;&nbsp;&nbsp;共&nbsp;<span style="color:#0486fe;">1</span>&nbsp;项</span>
          </div>
        </el-col>
      </el-row>

      <div style="margin-top: 10px">
        <el-row class="box">
          <el-col  :span="2" style="padding-right: 10px">编号</el-col>
          <el-col  :span="8" style="padding-right: 10px">保养标准方法</el-col>
          <el-col  :span="14" style="padding-right: 10px">报告项</el-col>
        </el-row>

        <el-row class="row">
          <el-col :span="2" style="padding-right: 10px">
            <spna>1</spna>
          </el-col>

          <el-col :span="8" style="padding-right: 10px">
            <el-input v-model="formData.maintenance_method"  placeholder="保养标准方法"></el-input>
          </el-col>

          <el-col :span="14">
            <el-checkbox name="time_consuming" disabled v-model="formBoolData.time_consuming "  label="耗时（分）" />
            <el-radio-group v-model="formBoolData.pm_type">
              <el-radio value="replace_part" label="replace_part">更换部品</el-radio>
              <el-radio value="oil_usage" label="oil_usage">油品用量</el-radio>
            </el-radio-group>
          </el-col>

        </el-row>

        <div style="margin-top: 20px;text-align: center">
          <el-button color="#0486fe" style="width: 100px" @click="editPosition" :loading="loading">保存编辑</el-button>
        </div>
      </div>

    </el-form>

  </div>
</template>

<script>

export default {
  name: "EqStandardZhiZaoEdit",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      formData: this.parentData,
      formBoolData:{
        time_consuming: this.parentData.time_consuming === '√'? true: false,
        pm_type: ''
      },
      eqDeviceTypeAll: [],
      eqPositionTypeAll: [],
      rules: {
        star1: [{required: true, message: '', trigger: 'blur'}],
        star2: [{required: true, message: '', trigger: 'blur'}],
      },
    }
  },
  computed: {

  },
  methods:{
    async getEqDeviceTypeAll() {
      let {data: res} = await this.$axios.get('/eq/maintenancePosition/getEqDeviceTypeAll');
      this.eqDeviceTypeAll = res.data;
    },
    async getEqPositionTypeAll() {
      let {data: res} = await this.$axios.get('/eq/position/getEqPositionTypeAll');
      this.eqPositionTypeAll = res.data;
    },
    editPosition(){
      if (!this.formData.device_id) {
        return this.$message.error('设备类型不能为空!')
      }

      if (!this.formData.position_id) {
        return this.$message.error('部品名称不能为空!')
      }

      if (!this.formData.maintenance_method) {
        return this.$message.error('保养标准方法不能为空!')
      }

      let params = {formData: this.formData, formBoolData: this.formBoolData};
      this.loading = true;
      this.$axios.post('eq/position/editPosition', params).then(response => {
        this.loading = false;
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }
        this.setting.$fn.closeWindow();
        this.setting.$fn.reSearch();
        return this.$message.success('编辑成功!');
      })
    }

  },created() {
    this.getEqDeviceTypeAll()
    this.getEqPositionTypeAll()
    if (this.parentData.replace_part === "√"){
      this.formBoolData.pm_type = 'replace_part'
    }
    if (this.parentData.oil_usage === "√"){
      this.formBoolData.pm_type = 'oil_usage'
    }
  }
}
</script>

<style scoped>
.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
  width: 650px;
  margin-left: 80px
}
.close {
  position: absolute;
  top: 5px;
  margin-left: -40px;
  font-size: 18px;
  cursor: pointer;
}
.row {
  margin-left: 80px;
  width: 650px;
  margin-top: 10px;
  height: 35px;
  line-height: 35px;
  text-align: center;
}
</style>